// Which orders count towards the dashboard numbers, and how payments are netted.
// delivery_status is the live workflow field; the legacy `status` column is only a default now
// (usually 'material_checking') and must not be used to decide what counts as revenue.

export function isCancelledOrder(order) {
    return (order.delivery_status || 'preparing') === 'cancelled' || order.status === 'cancelled';
}

// Real, non-cancelled orders: the only ones that count as sales/income (test orders and giveaways never do).
export function isCountedOrder(order) {
    return !isCancelledOrder(order) && !order.is_test && !order.is_marketing;
}

const num = (v) => parseFloat(v || 0) || 0;

// Payments received minus refunds. A fully paid order counts as its full total even if amount_paid is stale.
export function orderMoneyReceived(order) {
    const total = num(order.total);
    const paid = num(order.amount_paid);
    const isPaid = order.payment_status === 'paid' || order.is_paid === true || order.is_paid === 1 || paid.toFixed(2) >= total.toFixed(2);
    return Math.max(0, (isPaid ? total : paid) - num(order.refunded));
}

// Order value after refunds, so a refund is not reported as outstanding.
export function orderNetValue(order) {
    return Math.max(0, num(order.total) - num(order.refunded));
}

// Orders shown in the dashboard "Order Deliveries" calendar: those with a delivery date, never cancelled ones, soonest first.
// delivery_date is the single date the API serves for every screen (the promised expected date wins over the default).
export function calendarOrders(orders) {
    return (orders || [])
        .filter((o) => o.delivery_date && !isCancelledOrder(o))
        .sort((a, b) => String(a.delivery_date).slice(0, 10).localeCompare(String(b.delivery_date).slice(0, 10)));
}

// The real fulfilment state the Orders list shows (never the retired `status` column, which reads "material checking").
export function calendarStatusKey(order) {
    return order.delivery_status || 'preparing';
}

// 'YYYY-MM-DD' -> local Date (no UTC midnight shift into the previous day)
export function localDateFromKey(key) {
    const [y, m, d] = String(key).slice(0, 10).split('-').map(Number);
    return new Date(y, m - 1, d);
}
